import { createVueComponent } from '@tabler/icons-vue';

/**
 * A circled tick, using IconCheck's tick instead of Tabler's.
 *
 * The tick is bigger than Tabler's small one, so it fills the circle about as
 * much as Apple's does.
 */
export default createVueComponent('outline', 'circle-check', 'CircleCheck', [
    ['path', { d: 'M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
    ['path', { d: 'M8.25 12.55l2.4 2.95l5.1 -6.7', key: 'svg-1' }],
]);
